import {
  APP_STORE_ANDROID_URL,
  APP_STORE_APPLE_URL,
} from '../constants/appStores';
import { CONTACT_EMAIL, INSTAGRAM_URL } from '../constants/contact';
import { SITE_NAME } from '../constants/seo';

/**
 * JSON-LD reutilizável para SEO (Google) e citação em motores generativos (GEO).
 */
export function buildOrganizationSchema(siteUrl, logoUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: siteUrl,
    logo: logoUrl,
    email: CONTACT_EMAIL,
    sameAs: [INSTAGRAM_URL, APP_STORE_APPLE_URL, APP_STORE_ANDROID_URL].filter(Boolean),
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: CONTACT_EMAIL,
      availableLanguage: 'pt-BR',
      areaServed: {
        '@type': 'Country',
        name: 'Brasil',
      },
    },
  };
}

export function buildWebSiteSchema(siteUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: siteUrl,
    inLanguage: 'pt-BR',
    description:
      'Plataforma brasileira que conecta clientes a videomakers sob demanda, com pagamento em escrow e app para iOS e Android.',
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: siteUrl,
    },
  };
}

export function buildMobileApplicationSchema(siteUrl) {
  return {
    '@context': 'https://schema.org',
    '@type': 'MobileApplication',
    name: SITE_NAME,
    operatingSystem: 'iOS, Android',
    applicationCategory: 'BusinessApplication',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'BRL',
    },
    downloadUrl: [APP_STORE_APPLE_URL, APP_STORE_ANDROID_URL],
    url: siteUrl,
    inLanguage: 'pt-BR',
    description:
      'App para contratar videomakers perto de você ou receber jobs de vídeo como videomaker, com chat, escrow e pagamento via Stripe.',
    publisher: {
      '@type': 'Organization',
      name: SITE_NAME,
      url: siteUrl,
    },
  };
}

export function buildFaqPageSchema(faqItems, pageUrl) {
  const items = (faqItems || []).filter((item) => item?.q && item?.a);
  if (!items.length) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
    ...(pageUrl ? { url: pageUrl } : {}),
  };
}

export function buildWebPageSchema({ name, description, url, siteUrl }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    inLanguage: 'pt-BR',
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: siteUrl,
    },
  };
}
